<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";

defineProps<{ secret: string; label?: string }>();
const emit = defineEmits<{ (e: "dismiss"): void }>();

const { t } = useI18n();
const copied = ref(false);

async function copy(secret: string) {
  try {
    await navigator.clipboard.writeText(secret);
    copied.value = true;
    setTimeout(() => (copied.value = false), 1500);
  } catch {
    copied.value = false;
  }
}
</script>

<template>
  <div class="secret">
    <p class="secret__warn">{{ label ?? t("admin.secret.warn") }}</p>
    <code class="secret__value">{{ secret }}</code>
    <div class="secret__actions">
      <button type="button" class="secret__copy" @click="copy(secret)">
        {{ copied ? t("admin.secret.copied") : t("admin.secret.copy") }}
      </button>
      <button type="button" class="secret__dismiss" @click="emit('dismiss')">
        {{ t("admin.secret.done") }}
      </button>
    </div>
  </div>
</template>

<style scoped>
.secret {
  padding: 0.85rem 1rem;
  border: 1px solid var(--color-warn);
  border-radius: 6px;
  background: color-mix(in srgb, var(--color-warn) 8%, transparent);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.secret__warn {
  margin: 0;
  font-size: 0.85rem;
  color: var(--color-warn);
}
.secret__value {
  font-family: var(--font-mono);
  font-size: 0.95rem;
  background: var(--color-bg);
  padding: 0.4rem 0.6rem;
  border-radius: 4px;
  user-select: all;
  word-break: break-all;
}
.secret__actions {
  display: flex;
  gap: 0.5rem;
}
.secret__actions button {
  padding: 0.35rem 0.7rem;
  border-radius: 4px;
  border: 1px solid var(--color-border);
  background: var(--color-bg);
  color: var(--color-fg);
  cursor: pointer;
}
.secret__copy {
  font-weight: 500;
}
</style>
